module.exports = __webpack_public_path__ + "Server-CalamariNeedsUpgrade.TentacleActive.f3bdc05e78cc96d01e36e82af428ddda.hashedasset.svg";